import React from 'react'
// import './InfoRow.css'

export function hasAdditionalInfo(data) {
  return !!(
    (data?.brand && data?.brand !== 'Other') ||
    data?.shade ||
    data?.milky ||
    data?.eyeClean ||
    (data?.origin && data?.origin !== 'Other' && data?.origin !== 'NONE' && data?.origin !== 'NON') ||
    (data?.growthType && data?.growthType !== 'Other' && data?.growthType !== 'NONE' && data?.growthType !== 'NON') ||
    (data?.treatment && data?.treatment !== 'Other' && data?.treatment !== 'NONE' && data?.treatment !== 'NON') ||
    data?.keyToSymbol
  );
}

function AdditionalInfo({data}) {
  return (
  <div className="specGrid">
    <div>
        {data?.brand && data?.brand !== 'Other' ? 
            <div className="specRow">
                <div className="specLabel">Brand</div>
                <div className='specValue'>{data?.brand || "-"}</div>
            </div>
        : null}

      {data?.shade ?
        <div className="specRow">
            <div className="specLabel">Shade</div>
            <div className='specValue'>{data?.shade || "-"}</div>
        </div>: null}


      {data?.milky ? <div className="specRow">
        <div className="specLabel">Milky</div>
        <div className='specValue'>{data?.milky || "-"}</div>
      </div> : null}

      {data?.eyeClean ? <div className="specRow">
        <div className="specLabel">Eye Clean</div>
        <div className='specValue'>{data?.eyeClean || "-"}</div>
      </div> : null}
    </div>

    <div>
        {data?.origin && data?.origin !== 'Other' && data?.origin !== 'NONE' && data?.origin !== 'NON' ?
            <div className="specRow">
                <div className="specLabel">Origin</div>
                <div className='specValue'>{data?.origin || "-"}</div>
            </div>
        : null
        }
        {data?.growthType && data?.growthType !== 'Other' && data?.growthType !== 'NONE' && data?.growthType !== 'NON' ?
            <div className="specRow">
                <div className="specLabel">Growth Type</div>
                <div className='specValue'>{data?.growthType || "-"}</div>
            </div>
        : null
        }
        {data?.treatment && data?.treatment !== 'Other' && data?.treatment !== 'NONE' && data?.treatment !== 'NON' ?
            <div className="specRow">
                <div className="specLabel">treatment</div>
                <div className='specValue'>{data?.treatment || "-"}</div>
            </div>
        : null
        }
        {data?.keyToSymbol ?
            <div className="specRow">
                <div className="specLabel">Key To Symbol</div>
                <div className='specValue'>{data?.keyToSymbol || "-"}</div>
            </div>
        : null
        }
    </div>
  </div>
  )
}

export default AdditionalInfo